import React from 'react';
import { volunteerOptions } from '../../data/registration';
import { useProto } from '../../contexts/PrototypeContext';
export function VolunteerOptions({
  size
}: {
  size: 'mobile' | 'desktop';
}) {
  const {
    state,
    actions
  } = useProto();
  const desktop = size === 'desktop';
  return <fieldset className={desktop ? 'mx-auto w-fit' : ''} data-id="element-386" data-mp="2hjfjl8q4dbxv">
      <legend className="sr-only" data-id="element-387" data-mp="2hl0eizgciww9">Would you like to volunteer this season?</legend>
      <div className={desktop ? 'space-y-1' : 'space-y-0.5'} data-id="element-388" data-mp="2miaeva59wsyv">
        {volunteerOptions.map(o => {
        const checked = state.choice === o.id;
        return <label key={o.id} className="group flex cursor-pointer items-center gap-3.5 rounded-md px-2 py-2.5 font-i9 transition-colors duration-150 hover:bg-i9-surface" data-id="element-389" data-mp="2vau8txame9dd">
              <input type="radio" name="volunteer" value={o.id} checked={checked} onChange={() => actions.selectChoice(o.id)} className="peer sr-only" data-id="element-390" data-mp="35al07q3vw898" />
              <span aria-hidden="true" className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 transition-colors duration-150 peer-focus-visible:ring-2 peer-focus-visible:ring-i9-steel peer-focus-visible:ring-offset-2 ${checked ? 'border-i9-red bg-i9-red' : 'border-i9-radio bg-white group-hover:border-i9-steel'}`} data-id="element-391" data-mp="uo6n9wvptsqu">
                {checked && <span className="h-2 w-2 rounded-full bg-white" data-id="element-392" data-mp="1dfpt0bh4jkwk" />}
              </span>
              <span className={`text-[16px] ${checked ? 'font-medium text-i9-ink' : 'text-i9-ink/85'}`} data-id="element-393" data-mp="18mmvxtd51tbm">{o.label}</span>
            </label>;
      })}
      </div>
    </fieldset>;
}